import '@model/AccountDetailedDto'

import { OnboardingFlowTypeEnum } from '@pages/Signup/Components/SignupStep'

import { AccountDetailedDto } from '@model/AccountDetailedDto'

export const isAccountCompanyDepositStandard = (
  account: AccountDetailedDto | undefined
): boolean => {
  return account?.visibilityConfiguration.onboardingFlowType.id === OnboardingFlowTypeEnum.Standard
}

export const isAccountSkipCompanyDocuments = (account: AccountDetailedDto | undefined): boolean => {
  return !!account?.visibilityConfiguration.skipDocuments
}

export const isAccountProofOfIdentificationVerified = (
  account: AccountDetailedDto | undefined
): boolean => {
  return !!account?.visibilityConfiguration?.poiVerified
}
